import { render, staticRenderFns } from "./Delivery-Note-Remark.vue?vue&type=template&id=4bd87b10"
import script from "./Delivery-Note-Remark.vue?vue&type=script&lang=js"
export * from "./Delivery-Note-Remark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports